// ============================================================================
// ErrorBoundaryAramis.js — filet de sécurité racine (lot Fiabilité 4)
// ============================================================================
// Ne fait RIEN tant que l'app fonctionne (rend children tels quels). En cas
// d'erreur de rendu React — qui produisait jusqu'ici un écran blanc — il
// journalise (erreursFront) et affiche un écran de reprise avec rechargement.
// Styles inline volontairement autonomes (l'erreur peut survenir avant le
// chargement du thème).
import React from "react";
import { logErreurFront } from "./erreursFront";
import { IconeTexte } from "./icones";

export default class ErrorBoundaryAramis extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error, info) {
    logErreurFront({
      message: error && error.message,
      stack: error && error.stack,
      source: "react",
      composant: info && info.componentStack ? String(info.componentStack).slice(0, 200) : "",
    });
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      // var(--vh100, 100vh) : le repli n'est PAS decoratif. La variable est
      // posee par la feuille injectee dans un effet d'App ; si le plantage
      // survient au TOUT PREMIER rendu, cet effet n'a jamais tourne et
      // var(--vh100) seul serait invalide — min-height retomberait a `auto` et
      // l'ecran de secours perdrait son centrage plein ecran, au bureau aussi.
      <div style={{ minHeight: "var(--vh100, 100vh)", display: "flex", alignItems: "center",
        justifyContent: "center", background: "#f4f6f6", padding: 20,
        fontFamily: "-apple-system, 'Segoe UI', sans-serif" }}>
        <div style={{ maxWidth: 420, background: "#fff", borderRadius: "var(--radius-lg)",
          padding: "32px 28px", textAlign: "center",
          boxShadow: "0 8px 40px rgba(0,63,89,.12)" }}>
          <div style={{ fontSize: "var(--fs-display)" }}><IconeTexte nom="lifebuoy" titre="Aide"/></div>
          <div style={{ fontSize: "var(--fs-accroche)", fontWeight: 700, color: "#003F59", margin: "10px 0 6px" }}>
            Une erreur est survenue
          </div>
          <div style={{ fontSize: "var(--fs-meta)", color: "#5b6e79", lineHeight: 1.5, marginBottom: 20 }}>
            L'incident a été signalé automatiquement à l'équipe.
            Vos données ne sont pas affectées.
          </div>
          <button onClick={() => window.location.reload()}
            style={{ background: "#E87722", color: "#fff", border: "none",
              borderRadius: "var(--radius-md)", padding: "12px 26px", fontSize: "var(--fs-nav)",
              fontWeight: 700, cursor: "pointer" }}>
            Recharger Aramis
          </button>
        </div>
      </div>
    );
  }
}
